import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiSun } = FiIcons;

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  
  const navLinks = [
    { name: 'Our Story', href: '#story' },
    { name: 'Solutions', href: '#products' },
    { name: 'Business', href: '#opportunity' },
  ];

  return (
    <nav className="fixed w-full z-50 bg-white/95 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-2 cursor-pointer group">
            <div className="w-10 h-10 bg-[#FFC425] rounded-lg flex items-center justify-center shadow-lg shadow-yellow-200 group-hover:rotate-12 transition-transform">
              <SafeIcon icon={FiSun} className="text-2xl text-[#2A1A0F]" />
            </div>
            <span className="font-black text-xl tracking-tighter text-[#2A1A0F]">
              PETE & ROSEMARY
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.href}
                className="text-[#2A1A0F] hover:text-[#005b2d] font-bold text-sm uppercase tracking-widest transition-colors"
              >
                {link.name}
              </a>
            ))}
            <div className="flex gap-4">
              <a
                href="https://calendar.app.google/dh6SNXxpFN8eeH6x9"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-[#2A1A0F] border-2 border-[#2A1A0F] px-7 py-2.5 rounded-full font-bold text-xs uppercase tracking-widest hover:bg-[#2A1A0F] hover:text-white transition-all"
              >
                Book a Call
              </a>
              <a
                href="https://beta.neolife.com/peteandrosemary/en-US"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#005b2d] text-white px-7 py-3 rounded-full font-bold text-xs uppercase tracking-widest hover:bg-[#004221] transition-all shadow-md shadow-[#005b2d]/20"
              >
                Shop Now
              </a>
            </div>
          </div>

          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-[#2A1A0F] p-2">
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden bg-white border-b border-slate-100 shadow-xl"
          >
            <div className="px-4 pt-4 pb-8 space-y-2">
              {navLinks.map((link) => (
                <a 
                  key={link.name} 
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="block px-4 py-4 text-base font-bold text-[#2A1A0F] hover:text-[#005b2d] hover:bg-slate-50 rounded-xl"
                >
                  {link.name}
                </a>
              ))}
              <div className="pt-4 px-4 space-y-4">
                <a
                  href="https://calendar.app.google/dh6SNXxpFN8eeH6x9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-center bg-white text-[#2A1A0F] border-2 border-[#2A1A0F] py-4 rounded-full font-bold uppercase tracking-widest text-sm"
                >
                  Book a Call
                </a>
                <a 
                  href="https://beta.neolife.com/peteandrosemary/en-US" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block w-full text-center bg-[#005b2d] text-white py-4 rounded-full font-bold uppercase tracking-widest text-sm"
                >
                  Shop NeoLife
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}